
const ko = require('knockout');

const $ = require('jquery');
require('rgs-typeahead');

ko.bindingHandlers.typeahead = {
	init: function (element, valueAccessor, allBindings) {
		const $element = $(element);

		ko.computed(() => {
			const args = [].concat(ko.unwrap(valueAccessor()));
			$element.typeahead('destroy');
			$element.typeahead(...args);
		}, null, { disposeWhenNodeIsRemoved: element });

		if (allBindings.has('value')) {
			const updateFromModel = function () {
				const newValue = ko.unwrap(allBindings.get('value')) || '';
				const elementValue = $element.typeahead('val') || '';

				const valueHasChanged = (newValue !== elementValue);

				if (valueHasChanged) {
					$element.typeahead('val', newValue);
				}
			};

			ko.computed(updateFromModel, null, { disposeWhenNodeIsRemoved: element });

			$element.on('typeahead:change typeahead:select', function () {
				const observable = allBindings.get('value');
				if (!ko.isWritableObservable(observable)) {
					return;
				}
				const elementValue = String($element.typeahead('val'));
				const modelValue = observable.peek();

				const valueHasChanged = (modelValue !== elementValue);


				if (valueHasChanged) {
					observable(elementValue);
				}
			});

			$element.on('keyup', function () {
				const observable = allBindings.get('value');
				if (!ko.isWritableObservable(observable)) {
					return;
				}
				const elementValue = $element.typeahead('val');

				if (!elementValue) {
					observable('');
				}
			});
		}
	},
};

ko.bindingHandlers.typeaheadOpen = {
	init: function (element, valueAccessor) {
		const $element = $(element);

		$element.on('typeahead:beforeclose', function (e) {
			if (ko.unwrap(valueAccessor())) {
				e.preventDefault();
			}
		});

		$element.on('typeahead:beforeopen', function (e) {
			if (!ko.unwrap(valueAccessor())) {
				e.preventDefault();
			}
		});
	},
	update: function (element, valueAccessor) {
		$(element).typeahead(
			ko.unwrap(valueAccessor())
				? 'open'
				: 'close'
		);
	},
};
